import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import * as actions from '@/store/applyTemplate/actions';
import { getTemplates } from '../../template/template-api';

interface UseGetTemplatesOptions {
  fetchShares?: boolean;
  enabled?: boolean;
}

function getTemplatesQueryKey(fetchShares: boolean = true) {
  return ['templates', fetchShares];
}

export function useGetTemplates(options: UseGetTemplatesOptions = {}) {
  const { fetchShares = true, enabled = true } = options;
  const dispatch = useDispatch();

  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- dispatch is stable and intentionally excluded from the query key
  return useQuery({
    queryKey: getTemplatesQueryKey(fetchShares),
    async queryFn() {
      const response = await getTemplates({ fetchShares });
      const templates = response.result;

      // Redux is a fact of life in this project
      dispatch(actions.fetchTemplatesDone(templates));
      return templates;
    },
    enabled,
  });
}
